import { BufferUsage } from "../../../../../RenderEngine/RenderEnum/BufferTargetType";
import { DrawType } from "../../../../../RenderEngine/RenderEnum/DrawType";
import { MeshTopology } from "../../../../../RenderEngine/RenderEnum/RenderPologyMode";
import { VertexDeclaration } from "../../../../../RenderEngine/VertexDeclaration";
import { VertexElement } from "../../../../../renders/VertexElement";
import { VertexElementFormat } from "../../../../../renders/VertexElementFormat";
import { BufferState } from "../../../../../webgl/utils/BufferState";
import { Laya3DRender } from "../../../../RenderObjs/Laya3DRender";
import { GeometryElement } from "../../../GeometryElement";
const SCREENQUAD_POSITION_UV = 0;
const _vertices = new Float32Array([
    1, 1, 1, 1,
    1, -1, 1, 0,
    -1, 1, 0, 1,
    -1, -1, 0, 0
]);
const _verticesInvertUV = new Float32Array([
    1, 1, 1, 0,
    1, -1, 1, 1,
    -1, 1, 0, 0,
    -1, -1, 0, 1
]);
var _vertexDeclaration;
export class ScreenQuad extends GeometryElement {
    static __init__() {
        _vertexDeclaration = new VertexDeclaration(16, [new VertexElement(0, VertexElementFormat.Vector4, SCREENQUAD_POSITION_UV)]);
        ScreenQuad.instance = new ScreenQuad();
        ScreenQuad.instance.invertY = true;
        ScreenQuad.InvertInstance = new ScreenQuad();
        ScreenQuad.InvertInstance.invertY = false;
    }
    constructor() {
        super(MeshTopology.TriangleStrip, DrawType.DrawArray);
        this._bufferState = new BufferState();
        this._bufferStateInvertUV = new BufferState();
        this.setDrawArrayParams(0, 4);
        this._vertexBuffer = Laya3DRender.renderOBJCreate.createVertexBuffer3D(16 * 4, BufferUsage.Static, false);
        this._vertexBuffer.vertexDeclaration = _vertexDeclaration;
        this._vertexBuffer.setData(_vertices.buffer);
        this._bufferState.applyState([this._vertexBuffer], null);
        this._vertexBufferInvertUV = Laya3DRender.renderOBJCreate.createVertexBuffer3D(16 * 4, BufferUsage.Static, false);
        this._vertexBufferInvertUV.vertexDeclaration = _vertexDeclaration;
        this._vertexBufferInvertUV.setData(_verticesInvertUV.buffer);
        this._bufferStateInvertUV.applyState([this._vertexBufferInvertUV], null);
        this.invertY = false;
    }
    set invertY(value) {
        this.bufferState = value ? this._bufferStateInvertUV : this._bufferState;
    }
    _updateRenderParams(state) {
    }
    destroy() {
        super.destroy();
        this._bufferState.destroy();
        this._vertexBuffer.destroy();
        this._bufferStateInvertUV.destroy();
        this._vertexBufferInvertUV.destroy();
    }
}
